import { authHeader, check419 } from "../helpers";

export const documentService = {
    getList,
    add,
    update,
    delete: _delete,
};

function getList() {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({}),
    };

    return fetch(process.env.REACT_APP_APIURL + "documents/list", requestOptions).then(handleResponse);
}

// formData: title, document (file) and id on update
function add(formData) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: formData,
    };

    return fetch(process.env.REACT_APP_APIURL + "documents/add", requestOptions).then(handleResponse);
}

function update(formData) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: formData,
    };

    return fetch(process.env.REACT_APP_APIURL + "documents/update", requestOptions).then(handleResponse);
}

function _delete(info) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(info),
    };

    return fetch(process.env.REACT_APP_APIURL + "documents/delete", requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 419) {
                check419();
            }
            const error = (data && data.data && data.data.errors) || { common: [response.statusText] };
            return Promise.reject(error);
        }

        return data;
    });
}
